module.exports = __webpack_public_path__ + "static/media/RD_Logos_1.0a9754cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RD_Logos_1.png
// module id = 309
// module chunks = 0